import { ActionType } from "../actions/pos";

export const initialState = {
  list: [],
  type: "",
  data: {},
  bool: false,
  authUser: {},
  stores: [],
  defStore: {},
};

export const pos = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.List:
      return {
        ...state,
        list: [...action.payload.result],
        type: action.payload.type,
      };
    case ActionType.AddItem:
      return {
        ...state,
        list: [action.payload.result, ...state.list],
        type: action.payload.type,
      };
    case ActionType.UpdateItem:
      return {
        ...state,
        list: state.list.map((j) =>
          j.id === action.payload.result.id ? action.payload.result : j
        ),
      };
    case ActionType.Data:
      return {
        ...state,
        data: action.payload.result,
        type: action.payload.type,
      };
    case ActionType.RmvList:
      return {
        ...state,
        list: state.list.filter((j) => j.id !== action.payload.result.id),
      };
    case ActionType.Check:
      return {
        ...state,
        type: action.payload.type,
        bool: action.payload.result,
      };
    case ActionType.Auth:
      return {
        ...state,
        authUser: action.payload.result,
      };
    case ActionType.Store:
      return {
        ...state,
        stores: action.payload.result,
      };
    case ActionType.DefStore:
      return {
        ...state,
        defStore: action.payload.result,
      };
    case ActionType.RmvStore:
      return {
        ...state,
        stores: state.stores.filter((j) => j.id !== action.payload.result.id),
      };
    case ActionType.ClearLi:
      return {
        ...state,
        list: [],
        type: "",
      };
    case ActionType.ClearData:
      return {
        ...state,
        data: {},
        type: "",
      };

    default:
      return state;
  }
};
